import { useTranslation } from 'react-i18next';
import { Loader2, Send } from 'lucide-react';

function QueueSelectedBar({
  count,
  onQueue,
  loading,
}: {
  count: number;
  onQueue: () => void;
  loading: boolean;
}) {
  const { t } = useTranslation();
  if (count === 0) return null;

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 bg-[var(--color-bg-secondary)] border border-[var(--color-border)] rounded-xl shadow-xl px-6 py-3 flex items-center gap-4">
      <span className="text-sm text-[var(--color-text)] font-medium">
        {count} {t('pub.feed.selected')}
      </span>
      <button
        onClick={onQueue}
        disabled={loading}
        className="flex items-center gap-1.5 px-4 py-2 bg-green-600 text-white rounded-lg text-sm font-medium hover:bg-green-700 disabled:opacity-50"
      >
        {loading ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
        {t('pub.feed.queueSelected')}
      </button>
    </div>
  );
}

export { QueueSelectedBar };
